// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__CX2dx","modal":"styles_modal__KKQ5Q","container":"styles_container__0_K_Q","btnClose":"styles_btnClose__79YQn","btnBack":"styles_btnBack__UIFrg"};